import basedStyles from './basedStyles';
import globalStyles from './globalStyles';
import functions from './functions';
import colors from './colors';
import sizes from './sizes';

const { media, growOverParentPadding } = functions;

export {
  colors,
  sizes,
  media,
  growOverParentPadding,
  basedStyles,
  globalStyles,
};
